import { useEffect, useState } from 'react'
import { Box, Typography, CircularProgress } from '@mui/material'
import BedtimeIcon from '@mui/icons-material/Bedtime'
import useEarnings from '../hooks/useEarnings'

const PaymentStatus = () => {
  const { fetchLedgerUrl, fetchPaymentsUrl } = useEarnings()
  const [ledgerUrl, setLedgerUrl] = useState<string>('')
  const [paymentsUrl, setPaymentsUrl] = useState<string>('')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const updateUrls = async () => {
      setIsLoading(true)
      const ledger = await fetchLedgerUrl()
      const payments = await fetchPaymentsUrl()
      setLedgerUrl(ledger)
      setPaymentsUrl(payments)
      setIsLoading(false)
    }

    updateUrls()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const urlValid = (url: string | null) =>
    typeof url === 'string' && url.length > 0

  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      iframe: {
        border: 'none'
      }
    },
    ledgerIframe: {
      width: '90%',
      height: '700px',
      marginTop: '20px'
    },
    paymentsIframe: {
      margin: '20px auto',
      width: '90%',
      maxWidth: '740px',
      height: '700px'
    },
    noPBLMessage: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '700px'
    },
    bedtimeIcon: {
      fontSize: 120,
      mb: 2,
      color: 'text.secondary'
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '700px'
    }
  }

  if (isLoading) {
    return (
      <Box sx={styles.loadingContainer}>
        <CircularProgress size={60} />
      </Box>
    )
  }

  return (
    <Box sx={styles.container}>
      {urlValid(ledgerUrl) ? (
        <iframe
          role="looker-ledger"
          src={ledgerUrl}
          style={styles.ledgerIframe}
        />
      ) : (
        <Box sx={styles.noPBLMessage}>
          <BedtimeIcon sx={styles.bedtimeIcon} />
          <Typography align="center">
            This view has been automatically disabled due to inactivity.
            <br />
            Please reach out to your account manager if you would like to
            re-enable it.
          </Typography>
        </Box>
      )}
      {urlValid(paymentsUrl) ? (
        <iframe
          role="tipalti-payments"
          src={paymentsUrl}
          style={styles.paymentsIframe}
        />
      ) : (
        <Typography>
          Tipalti is not currently configured for your account.
          <br />
          Please reach out to your account manager if this is an error.
        </Typography>
      )}
    </Box>
  )
}

export default PaymentStatus
